/* eslint-disable react/button-has-type */
import React from 'react';
import { ButtonProps, ButtonVariant } from './types';

const variantClasses: Record<ButtonVariant, string> = {
  default: 'bg-doqit-bright-purple text-white',
  reversed: 'bg-doqit-purple-25 border border-doqit-bright-purple-600/20 text-doqit-bright-purple-600',
  inactive: 'bg-doqit-purple-200 text-doqit-purple-300 cursor-not-allowed',
};

export const TdButton = ({
  label,
  type = 'submit',
  isDisabled = false,
  variant,
  onClick,
  className,
  ...rest
}: ButtonProps) => {
  const resolvedVariant: ButtonVariant = variant ?? (isDisabled ? 'inactive' : 'default');
  const variantClass = variantClasses[resolvedVariant];

  return (
    <button
      type={type}
      className={`h-[65px] w-full rounded-[32.5px] px-[50px] py-3 text-[19px] tracking-[1px] capitalize font-bold font-body
        flex items-center justify-center shadow-[2px_2px_5px_rgba(24,0,100,0.15)] outline-none focus-visible:ring-2 focus-visible:ring-doqit-bright-purple-600
        transition-colors ${variantClass} ${className ?? ''}`}
      style={{ textShadow: resolvedVariant === 'default' ? '0px 2px 4px rgba(0,0,0,0.05)' : undefined }}
      disabled={isDisabled || resolvedVariant === 'inactive'}
      onClick={onClick}
      data-cy="submit-btn"
      {...rest}
    >
      {label}
    </button>
  );
};

export default TdButton;
